// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__O70CR","header":"ReportDetails_header__3XvcC","title":"ReportDetails_title__2sRgv","left":"ReportDetails_left__2Qto3"};